import { Component, OnInit } from '@angular/core';
import { Warehouse } from '../warehouse';
import { WarehouseService } from '../warehouse.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-warehouse-list',
  templateUrl: './warehouse-list.component.html',
  styleUrls: ['./warehouse-list.component.css']
})
export class WarehouseListComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  warehouse = new Warehouse();  //Po is defined from abobe import po
  warehouses: Warehouse[];
  submitted = false;
	message: string;	
	totalrecord:number;
  warehouseFilter: any = { warehousename: '' };

  constructor(
    private warehouseService: WarehouseService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getWarehouses();
  }

  getWarehouses() {
    this.spinnerService.show();
    return this.warehouseService.getWarehouse()
               .subscribe(
                warehouses => {
                  console.log(warehouses);
                  this.warehouses = warehouses
          this.totalrecord = this.warehouses.length;
          this.spinnerService.hide();
                 }
                );
 }

 update(): void {
  this.submitted = true;
  this.warehouseService.updateWarehouse(this.warehouse)
      .subscribe(() => this.message = "Warehouse Updated Successfully!");
}

delete(warehouseid): void {
  //this.submitted = true;
  this.warehouseService.deleteWarehouse(warehouseid)
      .subscribe(()=> this.message = "Warehouse Deleted Successfully!");
  this.getWarehouses();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

}

